import { render, staticRenderFns } from "./menuTask.vue?vue&type=template&id=11c82d9a&"
import script from "./menuTask.vue?vue&type=script&lang=js&"
export * from "./menuTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports